<template>
  <div class="box">
    <div
      class="detail"
      style="min-height: 500px"
      v-loading="loadNode"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>搜案例</el-breadcrumb-item>
        <el-breadcrumb-item>原文</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
      <!-- <div class="title">
      <h1>标题</h1>
      <p><span>推荐时间：2018-05-29</span><span>推荐人：罗奎</span></p>
    </div> -->
      <div id="text" v-html="content" class="box"></div>
      <!-- <div>{{ content }}</div> -->
      <div class="down">
        <el-dropdown>
          <el-button
            type="warning"
            size="mini"
            style="padding: 10px 10px; width: 78px; margin-right: 10px"
            >下载<i class="el-icon-download"></i
          ></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span @click="pdfDown(caseId)">PDF文件</span></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="wordDown(caseId)">WORD文件</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <br>
        <el-button
          type="warning"
          round
          @click="copyAll"
          class="btn"
          data-clipboard-target="#text"
          data-clipboard-action="copy"
          size="mini"
          style="margin: 20px 0px"
          >复制全文</el-button
        >
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import store from "@/store";
import ComFooter from "../../../../components/ComFooter.vue";
import Clipboard from "clipboard"; //引入安装复制插件
export default {
  inject: ["reload"],
  data() {
    return {
      caseId: null,
      content: null,
      loadNode: true,
    };
  },
  created() {
    this.caseDetail();
  },
  methods: {
    caseDetail() {
      this.caseId = this.$route.params.id;
      this.$http
        .get("/info?_id=" + this.caseId + "&keyword", {
          params: {},
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            this.content = res.data.data.Content;
            // console.log(this.content)

            // let or01 = location01.test(aa);
            // console.log(or01);
            // console.log(aa);
            this.loadNode = false;
          }
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((reeor) => {
          // console.log("catch:"+reeor);
          // store.clearCookie("token");
          // this.$router.push("/");
          // this.reload();
          // this.$message.error("登录过期！请重新登录");
        });
    },
    // PDF单篇下载
    pdfDown(id) {
      // console.log(id);
      this.$http
        .get("/pdf?_id=" + id, {})
        .then((res) => {
          // console.log(res);
          // window.location.href = res.data.data.url;
          window.open(res.data.data.url, "_blank");
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // word单篇下载
    wordDown(id) {
      // console.log(id);
      this.$http
        .get("/word?_id=" + id, {})
        .then((res) => {
          // console.log(res);
          // window.location.href = res.data.data.url;
          window.open(res.data.data.url, "_blank");
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 复制全文
    copyAll() {
      let textUrl = new Clipboard(".btn");
      textUrl.on("success", (e) => {
        console.log(e.action);
        this.$message({
          message: "复制成功",
          type: "success",
        });
        textUrl.destroy();
      });
      textUrl.on("error", () => {
        consold.log("没有复制成功");
        this.$message("没有复制成功");
        textUrl.destroy();
      });
      //创建一个 Input标签
      // let oInput = document.createElement("input");
      // oInput.value = this.detailAll.Content;
      // document.body.appendChild(oInput);
      // oInput.select(); // 选择对象;
      // console.log(oInput.value);
      // // 执行浏览器复制命令
      // /// 复制命令会将当前选中的内容复制到剪切板中
      // /// 如这里构建的 Input标签
      // document.execCommand("Copy");
      // this.$message({
      //   message: "复制成功",
      //   type: "success",
      // });
      // ///复制成功后再将构造的标签 移除
      // oInput.remove();
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style lang='less' scoped>
.box {
  background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 80%;
  background-repeat: no-repeat;
  min-height: calc(100vh - 240px);

  // min-width: 1260px;
}
.detail {
  // min-width: 1100px;
  max-width: 1260px;
  min-height: calc(100vh - 200px);
  margin: auto;
  position: relative;
  .down {
    position: absolute;
    right: -100px;
    top: 70px;
  }
  .breadcrumb {
    margin: 20px 0;
  }
  .title {
    background: #faf2ea;
    padding: 10px;
    border-radius: 10px;
    h1 {
      font-size: 21px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 10px;
      span {
        margin-right: 30px;
      }
    }
  }
  .box::-webkit-scrollbar {
    // display: none;
  }

  .box {
    margin: 20px 0;
    //   height: 500px;
    padding: 20px;
    border: none;
    font-size: 16px;
    line-height: 30px;
    text-indent: 2em;
    border-radius: 10px;
    background: rgb(255, 255, 255, 0.2);
    table {
      border-collapse: collapse;
      border-spacing: 0;
    }
    /deep/ table {
      margin: 10px 0;
      border: 1px solid rgb(160, 160, 160);
      text-align: center;
      border-collapse: collapse;
      tbody {
        tr {
          // border: 1px solid rgb(160, 160, 160);
          td {
            border: 1px solid rgb(160, 160, 160);
          }
        }
      }
    }

    //   overflow-x: hidden;
    // overflow-y: scroll;
    // background: #faf2ea;
    // /deep/ h2 {
    //   font-size: 32px;
    //   font-weight: 900;
    //   margin-bottom: 20px;
    // }
    // /deep/ div {
    //   font-weight: 900;
    //   min-height: 45px;
    // }
  }
}
// <template>
//   <div>
//     <button @click="increaseFontSize">字号 +</button>
//     <button @click="decreaseFontSize">字号 -</button>
//     <div :style="{ fontSize: fontSize + 'px' }">
//       这是一段测试文字
//     </div>
//   </div>
// </template>

// <script>
// export default {
//   data() {
//     return {
//       fontSize: 16, // 初始字体大小为 16px
//     };
//   },
//   methods: {
//     increaseFontSize() {
//       this.fontSize += 2; // 增加字体大小 2px
//     },
//     decreaseFontSize() {
//       this.fontSize -= 2; // 减小字体大小 2px
//     },
//   },
// };
// </script>
</style>



